import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import lang from '@blade-sxp/portrait-management/lang';
let default_1 = class default_1 extends Vue {
    formData;
    onFormData(nv) {
        if (!nv)
            return;
        console.log('onFormData', nv);
        this.$emit('update:formData', nv);
    }
    formLabelWidth = '100';
    handleChange() { }
};
__decorate([
    Prop({
        default: () => {
            return {
                date: [],
                totalCount: -1,
                type: 'STATIC',
            };
        },
    })
], default_1.prototype, "formData", void 0);
__decorate([
    Watch('formData', { deep: true, immediate: true })
], default_1.prototype, "onFormData", null);
default_1 = __decorate([
    Component({
        name: 'generatePassCode',
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
